import styled from 'styled-components';
import { ContainerV2 } from '../../../../../stories/atoms/containerV2/ContainerV2';

export const StyledGrid = styled(ContainerV2)`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
`;
